import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-gift-expired',
  templateUrl: './popup-gift-expired.component.html',
  styleUrls: ['./popup-gift-expired.component.sass']
})
export class PopupGiftExpiredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
